import LazyLoad from "react-lazyload";
import Loading2 from "../../../../../utils/Loader/Loading2";
import XrayEditor from "../XrayEditor";

const MedicalXrayImage = ({
  setRiskFactor,
  xrayImage,
  xrayLoading,
  userDetail,
  setXrayImage,
  setXrayLoading,
  stageRef,
  setHasDrawingActivity,
}) => {
  const xrayImageRestore = async () => {
    setXrayLoading(true);
    setXrayImage(userDetail?.user?.registration_no + ".JPG");
    // setRiskFactor("");
    await new Promise((resolve) => setTimeout(resolve, 100));

    setXrayLoading(false);
  };

  return (
    <div className="d-flex flex-column">
      <div className="w-auto d-flex justify-content-end h-100">
        {!xrayImage ? (
          <div
            className="d-flex align-items-center justify-content-center h-100 fs-4  border border-5 rounded-1 text-dark"
            style={{ width: "650px" }}
          >
            No X-ray Image Found
          </div>
        ) : (
          <div>
            <LazyLoad height={200} offset={100}>
              {xrayLoading ? (
                <Loading2 />
              ) : (
                <XrayEditor
                  xrayFilm={xrayImage}
                  stageRef={stageRef}
                  setRiskFactor={setRiskFactor}
                  onDrawingActivityChange={(hasDrawingActivity) => {
                    setHasDrawingActivity(hasDrawingActivity);
                  }}
                />
              )}
            </LazyLoad>
          </div>
        )}
      </div>
      <div className="w-100">
        {xrayImage && (
          <button
            className="btn btn-danger btn-sm fs-6 w-100"
            data-bs-toggle="modal"
            data-bs-target={`#restoreXray2`}
          >
            Restore Film
          </button>
        )}

        <div
          className="modal fade"
          id={`restoreXray2`}
          tabIndex={-1}
          style={{ display: "none" }}
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-dark">Restore X-Ray Film</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body pb-0">
                <div className="mb-3 row ">
                  <div className="col-sm-10">
                    <p className="text-dark">
                      Are you sure you want to restore X-Ray film?
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={xrayImageRestore}
                  data-bs-dismiss="modal"
                >
                  Yes
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-toggle="modal"
                  data-bs-target={`#restoreXray2`}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicalXrayImage;
